import { Select, Tooltip, Skeleton, Alert, Modal, Tabs, Button } from 'antd';
import { CloseOutlined, ReloadOutlined } from "@ant-design/icons";
import LinearProgress from '@mui/material/LinearProgress';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { toast } from 'react-toastify';
import Box from '@mui/material/Box';
import axios from "axios";
import dayjs from 'dayjs';

import { ContainerSearch, LoadingCircle } from "../styledGlobalModal";
import HeaderSideHom from "./HeaderSideHome";
import { SituacaoTarefa } from "./SituacaoTarefa";
import ModalEmitir from "./SituacaoTarefa/PendentesEmitir";
import TabelasTarefas from "./SituacaoTarefa/Tabelas/Tarefas";
import { TablePagination } from "../../../Pagination";
import usePagination from "../../../../service/usePagination";
import CriarNovaTarefa from "./CriarNovaTarefa";
import { exportTarefasExcel } from "../../../../service/exportExcel";
import "../Tarefas/style.css"
import listUfBrasil from "../../../../function/helpers/listUF.json"
import { getDiasCategoria } from "../../../../function/utilis/function";
import { ibge_POST } from "../../../../service/api";
import "./style.css";


import "../../../../bgGlobal.css";

export function Tarefas() {
  // --- Estados de Dados ---
  const [listTableTarefas, setListTableTarefas] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);

  // --- Estados de Seleção e Controle ---
  const [tarefaSelecionada, setTarefaSelecionada] = useState("");
  const [clienteSelecionado, setClienteSelecionado] = useState("");

  // --- Estados do Filtro (Essenciais para Sincronia com Exportação e HeaderSideHome) ---
  const [dataVencimento, setDataVencimento] = useState(null); // Data ISO
  const [clientId, setClientId] = useState("");
  const [carteira, setCarteira] = useState(null);
  const [equipe, setEquipe] = useState(null);
  const [selectObrigacao, setSelectObrigacao] = useState(""); // Nome Obrigação (Filtro Lateral)
  const [selectedArea, setSelectedArea] = useState("R");
  const [dataDay, setDataDay] = useState(null); // Dia do filtro lateral

  // --- Estados de Filtro Dinâmico (Barra Superior) ---
  const [obrigacaoIdToEmit, setObrigacaoIdToEmit] = useState([]);
  const [ufObrigacao, setUfObrigacao] = useState([]);
  const [municipioObrigacao, setMunicipioObrigacao] = useState([]);
  const [selectAmbito, setselectAmbito] = useState("");
  const [selectedTarefaSituacao, setTarefaSituacao] = useState("T");

  // --- Estados de UI/Loading ---
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false); // Botão Reload
  const [showMessage, setShowMessage] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [isExportDisabled, setIsExportDisabled] = useState(true);
  const [isSearchClient, setIsSearchClient] = useState(true);
  const [isTableTarefas, setIsTableTarefas] = useState(true);
  const [isHeaderVisible] = useState(true);

  // --- Estados de Modais ---
  const [isSituacaoTarefa, setIsSituacaoTarefa] = useState(false);
  const [isModalEmitirOpen, setIsModalEmitirOpen] = useState(false);
  const [isCriarNovaTarefa, setIsCriarNovaTarefa] = useState(false);
  const [taskIdToEmit] = useState(null);
  const [idDas] = useState("");
  const [msgErrorIdClient] = useState("");

  // --- Listas Auxiliares ---
  const [listTipoObrigacao, setListTipoObrigacao] = useState([]);
  const [todasObrigacoes, setTodasObrigacoes] = useState([]);
  const [listMunicipio, setListMunicipio] = useState([]);
  const listUfBrasileiro = listUfBrasil;

  // --- Paginação ---
  const [sitPend] = useState(() => JSON.parse(localStorage.getItem("SituacaoPendentes")) || false);
  const [pendentes, setPendentes] = useState(0);
  const [finalizadas, setFinalizadas] = useState(0);
  const [activeTab, setActiveTab] = useState("Pendentes");
  const [pagePendentes, setPagePendentes] = useState(1);
  const [pageFinalizadas, setPageFinalizadas] = useState(1);

  // --- Controle de Requisição ---
  const [abortController, setAbortController] = useState(null);

  const currentList = activeTab === "Pendentes"
    ? filteredList.filter((item) => Number(item.quantidadePrevisto) > Number(item.quantidadeEmitido))
    : filteredList.filter((item) => Number(item.quantidadePrevisto) === Number(item.quantidadeEmitido));

  const { count, slicedData } = usePagination(currentList, 7, activeTab === "Pendentes" ? pagePendentes : pageFinalizadas);

  // --- Effects ---
  useEffect(() => {
    localStorage.setItem('SituacaoPendentes', JSON.stringify(sitPend));
  }, [sitPend]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin === "http://localhost:8080" && event.data.type === 'sessao') {
        sessionStorage.setItem('USER', event.data.data);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    fetchDataObrigacoes();
    fetchDataFromLocalStorage();
  }, []);

  // --- API Functions ---

  const fetchData = async (
    dateVal,
    cliVal,
    cartVal,
    equipeVal,
    obrigacaoVal,
    areaVal,
    diaVal,
    signal
  ) => {
    try {
      setLoading(true);
      const url = "/portal/rest/contador/obrigacao/tarefa/listar";

      const params = {
        dataVencimento: dateVal,
        cliente: {
          id: cliVal ?? "",
          carteira: { id: cartVal ?? "" },
          equipe: { id: equipeVal ?? "" },
        },
        obrigacao: {
          nome: obrigacaoVal ?? "",
          recorrencia: { id: areaVal ?? "" },
          dia: diaVal ?? "",
        },
      };

      const response = await axios.post(url, params, { withCredentials: true, signal });

      if (response.status !== 200) {
        toast.error("Erro ao buscar os dados.");
        return;
      }
      if (response.data.erro) {
        toast.error(response.data.erro.mensagem);
        setListTableTarefas([]);
        return;
      }

      if (!response.data || response.data.length === 0) {
        setIsSearchClient(false);
        setShowMessage(true);
        setIsTableTarefas(false);
        setIsExportDisabled(true);
        setListTableTarefas([]);
      } else {
        setShowMessage(false);
        setListTableTarefas(response.data);
        setIsSearchClient(true);
        setIsExportDisabled(false);
        setClienteSelecionado(cliVal);
        setIsTableTarefas(true);
        localStorage.setItem("listTableTarefas", JSON.stringify(response.data));
      }

    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        console.error("Erro na requisição:", error);
        handleErrorResponse?.(error);
      }
    } finally {
      setLoading(false);
      setLoadingButton(false);
      setAbortController(null);
    }
  };

  // --- Handler Principal vindo do HeaderSideHome ---
  const handleFilterData = (
    valDataVencimento,
    valIdCliente,
    valCarteira,
    valEquipe,
    valObrigacaoNome,
    valSelectedArea,
    valSelectedDay
  ) => {
    // 1. Limpa visualização anterior
    setListTableTarefas([]);
    setTarefaSelecionada(null);
    setIsSituacaoTarefa(false);
    setActiveTab("Pendentes");
    setPagePendentes(1);
    setPageFinalizadas(1);

    // 2. ATUALIZA ESTADOS LOCAIS (CRUCIAL PARA EXPORTAÇÃO FUNCIONAR)
    setDataVencimento(valDataVencimento);
    setClientId(valIdCliente);
    setCarteira(valCarteira);
    setEquipe(valEquipe);
    setSelectObrigacao(valObrigacaoNome);
    setSelectedArea(valSelectedArea);
    setDataDay(valSelectedDay);

    // 3. Verifica se deve usar Cache ou API
    // Se todos os filtros estão vazios e temos data, talvez buscar do cache?
    // Ajustei para sempre buscar da API se vier do botão "Pesquisar", 
    // a menos que queira explicitamente o cache em refresh de tela.

    // Cancela requests anteriores
    if (abortController) abortController.abort();
    const controller = new AbortController();
    setAbortController(controller);

    fetchData(
      valDataVencimento,
      valIdCliente,
      valCarteira,
      valEquipe,
      valObrigacaoNome,
      valSelectedArea,
      valSelectedDay,
      controller.signal
    );
  };

  const fetchDataFromLocalStorage = () => {
    setIsSituacaoTarefa(false);
    // Limpa filtros visuais
    setClientId("");
    setCarteira(null);
    setEquipe(null);
    setSelectObrigacao("");

    const storedData = JSON.parse(localStorage.getItem("listTableTarefas")) || [];
    if (storedData.length > 0) {
      setListTableTarefas(storedData);
      setOriginalList(storedData);
      setIsTableTarefas(true);
      setIsExportDisabled(false);
    }
  };

  // --- Função do Botão de Recarregar (Reset) ---
  const handleButtonClick = () => {
    if (loadingButton) {
      abortController?.abort();
      setAbortController(null);
      toast.info("Requisição cancelada.");
      setLoadingButton(false);
      return;
    }

    // Reseta filtros para o padrão
    const dataVencPadrao = dayjs().date(15).hour(0).minute(0).second(0).toISOString();

    setDataDay(null);
    setClientId("");
    setCarteira(null);
    setEquipe(null);
    setSelectedArea("R");
    setSelectObrigacao("");
    // Atualiza dataVencimento no estado também
    setDataVencimento(dataVencPadrao);

    const controller = new AbortController();
    setAbortController(controller);
    setLoadingButton(true);

    fetchData(
      dataVencPadrao,
      "", null, null, "", "R", "",
      controller.signal
    );
  };

  // --- Export Excel ---
  const exportToExcel = async (reportValue) => {
    // Usa a data atual se não houver filtro, ou a data do filtro se houver
    const dataVencExport = dataVencimento || dayjs().date(15).toISOString();

    try {
      setExporting(true);
      await exportTarefasExcel({
        report: reportValue,
        diaVencimento: dataDay,     // Agora usa o estado correto
        dataVencimento: dataVencExport,
        nome: selectObrigacao,      // Agora usa o estado correto
        clienteId: clientId,        // Agora usa o estado correto
        categoriaId: selectedArea,  // Agora usa o estado correto
        // carteira: carteira,      // Adicione se sua função de export suportar
        // equipe: equipe           // Adicione se sua função de export suportar
      });
    } catch (e) {
      console.error(e);
      toast.error("Erro ao exportar os dados.");
    } finally {
      setExporting(false);
    }
  };

  const handleErrorResponse = (error) => {
    if (error.response) {
      if (error.response.status === 403) toast.error("Acesso negado (403)");
      else if (error.response.status === 404) toast.error("Não encontrado (404)");
      else toast.error("Erro na requisição.");
      setOriginalList([]);
      setIsSearchClient(false);
    }
  };

  // --- Lógica de Filtros Dinâmicos (Client Side) ---
  useEffect(() => {
    let filtradas = listTableTarefas;

    // Filtro Ambito
    if (selectAmbito && selectAmbito !== "TODOS") {
      if (selectAmbito === "F") filtradas = filtradas.filter(i => i.obrigacao?.ambito === "F");
      if (selectAmbito === "E") filtradas = filtradas.filter(i => i.obrigacao?.ambito === "E");
      if (selectAmbito === "M") filtradas = filtradas.filter(i => i.obrigacao?.ambito === "M");
    }

    // Filtro Obrigação (Select Multiplo)
    if (Array.isArray(obrigacaoIdToEmit) && obrigacaoIdToEmit.length > 0) {
      filtradas = filtradas.filter((item) => obrigacaoIdToEmit.includes(item.obrigacao?.id));
    }

    // Filtro UF
    if (Array.isArray(ufObrigacao) && ufObrigacao.length > 0) {
      filtradas = filtradas.filter((item) => ufObrigacao.includes(item.obrigacao.uf));
    }

    // Filtro Municipio
    if (Array.isArray(municipioObrigacao) && municipioObrigacao.length > 0) {
      filtradas = filtradas.filter((item) => municipioObrigacao.includes(item.obrigacao?.ibgeMunicipio));
    }

    // Ordenação
    filtradas = [...filtradas].sort((a, b) => {
      const catA = getDiasCategoria(Number(a.dia));
      const catB = getDiasCategoria(Number(b.dia));
      return catA !== catB ? catB - catA : Number(b.dia) - Number(a.dia);
    });

    // Totais
    const fin = filtradas.filter(i => Number(i.quantidadePrevisto) === Number(i.quantidadeEmitido));
    const pen = filtradas.filter(i => Number(i.quantidadePrevisto) !== Number(i.quantidadeEmitido));

    setFinalizadas(fin.length);
    setPendentes(pen.length);
    setFilteredList(filtradas);
    setPagePendentes(1);
    setPageFinalizadas(1);

  }, [selectAmbito, obrigacaoIdToEmit, ufObrigacao, municipioObrigacao, selectedTarefaSituacao, listTableTarefas]);

  // --- Busca Auxiliar ---
  const fetchDataObrigacoes = async () => {
    try {
      const response = await axios.post("/portal/rest/contador/obrigacao/tipo/listar", {}, { withCredentials: true });
      if (Array.isArray(response.data)) {
        const ativos = response.data.filter((item) => item.situacao?.id === "A");
        setTodasObrigacoes(ativos);
        setListTipoObrigacao(ativos);
      }
    } catch (error) {
      console.error("Erro obrigações:", error);
    }
  };

  const fetchIbge = async (ufSelecionada) => {
    try {
      const response = await ibge_POST(`/municipio/listar`, { uf: { sigla: ufSelecionada } });
      if (response) {
        setListMunicipio(response);
        setMunicipioObrigacao([]);
      }
    } catch (error) {
      setListMunicipio([]);
    }
  };

  // --- Filtro de Tipos de Obrigação baseado no Âmbito ---
  useEffect(() => {
    if (!selectAmbito || selectAmbito === "TODOS") {
      setListTipoObrigacao(todasObrigacoes);
      return;
    }
    const filtradas = todasObrigacoes.filter((item) => item.ambito === selectAmbito);
    setListTipoObrigacao(filtradas);
  }, [selectAmbito, todasObrigacoes]);

  const handleTabChange = (key) => setActiveTab(key);

  const items = [
    { key: "Pendentes", label: `Pendentes` },
    { key: "Finalizadas", label: `Finalizadas` },
  ];

  return (
    <>
      <div className="modal-container">
        {isHeaderVisible && (
          <HeaderSideHom onSearch={handleFilterData} loading={loading} />
        )}

        <div className="width-78">
          <div className="width-93 display-flex margin-0-auto margin-btn-15">
            <div className="width-100 display-flex align-item just-content-left">
              <Tooltip title="Nova tarefa">
                <div className="sty-btn bg-padrao" onClick={() => setIsCriarNovaTarefa(true)}>
                  <BiPlus />
                </div>
              </Tooltip>
            </div>

            <div className="result-filter">
              <div className="card-resumo pendentes">
                <span className="titulo">Pendentes</span>
                <span className="valor">{pendentes}</span>
              </div>
              <div className="card-resumo finalizadas">
                <span className="titulo">Finalizadas</span>
                <span className="valor">{finalizadas}</span>
              </div>

              <div className="display-just-center-align">
                <Tooltip title="Recarregar dados (Limpar filtros)">
                  <Button
                    color="primary"
                    style={{ border: "none", background: "transparent", borderRadius: "20px", width: "34px" }}
                    onClick={handleButtonClick}
                  >
                    {loadingButton ? <CloseOutlined /> : <ReloadOutlined />}
                  </Button>
                </Tooltip>
              </div>
            </div>

            <div className="display-flex just-content-center align-item">
              {!exporting && (
                <div className="flex just-content-center align-item text-align">
                  <Tooltip title="Exportação baseada nos filtros aplicados na busca principal.">
                    <Select
                      placeholder="Exportar Excel"
                      style={{ width: 200, height: 33 }}
                      onChange={(value) => exportToExcel(value)}
                      disabled={isExportDisabled}
                      options={[
                        {
                          label: <span>planilha controle</span>,
                          options: [
                            { label: <span>Excel - controle tarefas</span>, value: "0" },
                            { label: <span>Excel - tarefas inconsistentes</span>, value: "9" },
                          ],
                        },
                        {
                          label: <span>exportar</span>,
                          options: [
                            { label: <span>Excel - tarefas resumido</span>, value: "1" },
                            { label: <span>Excel - tarefas detalhado</span>, value: "2" },
                            { label: <span>dados - tarefas detalhado</span>, value: "12" },
                          ],
                        },
                      ]}
                    />
                  </Tooltip>
                </div>
              )}
              {exporting && (
                <div className="skeleton-container">
                  <LoadingCircle />
                </div>
              )}
            </div>
          </div>

          <div className="max-width-100 margin-0-auto">
            <div>
              <ContainerSearch>
                {isSearchClient && (
                  <>
                    <div className="title-filter"><span>Filtro Dinâmico</span></div>
                    <div className="width-93 display-flex margin-0-auto margin-btn-15 padding-10 border-rad box-shadow-padrao">
                      <div className="margin-right-10">
                        <Select
                          value={selectAmbito}
                          onChange={(value) => {
                            setselectAmbito(value);
                            if (value === "TODOS" || value === "F") {
                              setMunicipioObrigacao([]);
                              setUfObrigacao([]);
                            }
                          }}
                          placeholder="Selecione o Âmbito"
                          style={{ width: 200 }}
                          options={[
                            { label: "TODOS", value: "TODOS" },
                            { label: "Federal", value: "F" },
                            { label: "Estadual", value: "E" },
                            { label: "Municipal", value: "M" },
                          ]}
                        />
                      </div>

                      <div className="margin-right-10 width-100">
                        <Select
                          mode="multiple"
                          showSearch
                          allowClear
                          placeholder="Selecione obrigação"
                          style={{ width: "100%" }}
                          maxTagCount="responsive"
                          options={listTipoObrigacao.map((item) => ({
                            value: item.id,
                            label: `${item.sigla} - ${item.nome}`,
                          }))}
                          onChange={(values) => setObrigacaoIdToEmit(values)}
                          filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                          }
                        />
                      </div>

                      <div style={{ display: "flex", gap: "10px" }}>
                        {selectAmbito !== "F" && (
                          <>
                            <Select
                              mode="multiple"
                              showSearch
                              allowClear
                              placeholder="UF"
                              style={{ width: 120 }}
                              value={ufObrigacao}
                              options={listUfBrasileiro.map((item) => ({
                                value: item.uf,
                                label: item.uf,
                              }))}
                              onChange={(values) => {
                                setUfObrigacao(values);
                                if (values && values.length === 1) fetchIbge(values[0]);
                                else {
                                  setListMunicipio([]);
                                  setMunicipioObrigacao([]);
                                }
                              }}
                            />

                            <Select
                              mode="multiple"
                              showSearch
                              allowClear
                              placeholder="Município"
                              style={{ width: 260 }}
                              options={listMunicipio.map((m) => ({ value: m.id, label: m.nome }))}
                              value={municipioObrigacao}
                              onChange={(values) => setMunicipioObrigacao(values)}
                              disabled={listMunicipio.length === 0}
                              // ADICIONEI ESTA LINHA ABAIXO:
                              filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                              }
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </ContainerSearch>
            </div>

            <div>

              <div>
                {loading && <Box sx={{ width: "100%" }}><LinearProgress /></Box>}

                {msgErrorIdClient && (
                  <div className="effect"><Alert message={msgErrorIdClient} type="info" /></div>
                )}

                <div style={{ padding: 20 }}>
                  {isTableTarefas && (
                    <>
                      {loading ? (
                        <div style={{ padding: '20px' }}>
                          <Skeleton active />
                          <Skeleton active />
                        </div>
                      ) : (
                        <>
                          <Tabs defaultActiveKey={activeTab} items={items} onChange={handleTabChange} />
                          <TabelasTarefas
                            setTarefaSelecionada={setTarefaSelecionada}
                            setIsSituacaoTarefa={setIsSituacaoTarefa}
                            slicedData={slicedData}
                            loading={loading}
                          />
                          <TablePagination
                            count={count}
                            pagePendentes={pagePendentes}
                            pageFinalizadas={pageFinalizadas}
                            activeTab={activeTab}
                            setPagePendentes={setPagePendentes}
                            setPageFinalizadas={setPageFinalizadas}
                          />
                        </>
                      )}
                    </>
                  )}

                  {showMessage && (
                    <div className="width-93 display-flex margin-0-auto">
                      <Alert message="Nenhum dado encontrado." type="info" style={{ width: "100%" }} />
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Modal
        title="Lista de Itens de Tarefa"
        open={isSituacaoTarefa}
        onCancel={() => setIsSituacaoTarefa(false)}
        footer={null}
        width="90%"
      >
        <SituacaoTarefa
          idTarefa={tarefaSelecionada}
          selectedArea={selectedArea}
          clientId={clienteSelecionado}
          carteira={carteira}
          equipe={equipe}
          dataVencimento={dataVencimento}
        />
      </Modal>

      {isModalEmitirOpen && (
        <div className={`Emitir ${isModalEmitirOpen ? "active" : "inactive"}`}>
          <ModalEmitir
            isOpen={isModalEmitirOpen}
            taskId={taskIdToEmit}
            obrigacaoId={obrigacaoIdToEmit}
            idDas={idDas}
            onClose={() => setIsModalEmitirOpen(false)}
          />
        </div>
      )}

      <Modal
        title="Cria nova tarefa"
        open={isCriarNovaTarefa}
        onCancel={() => setIsCriarNovaTarefa(false)}
        footer={null}
        width="70%"
      >
        <CriarNovaTarefa
          fetchDataObrigacoes={fetchDataObrigacoes}
          setIsCriarNovaTarefa={setIsCriarNovaTarefa}
          listTipoObrigacao={listTipoObrigacao}
        />
      </Modal>
    </>
  );
}

export default Tarefas;